import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {quizzesEdit_template} from "../components/templates/quizzesEdit_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class quizzes_edit extends vnModule_knockoutJS {
    protected XHRHdl: XMLHttpRequestHandler;
    protected quizzesEdit: quizzesEdit_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    protected getModuleName() {
        return "quizzes_edit";
    }

    buildContent(): Array<Element> {
        this.quizzesEdit = new quizzesEdit_template("editForm", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Edit Quiz");

        return [this.quizzesEdit.build()];
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    public getQuizId() {
        return this.getVnAppZone().app.params.id || 0;
    }

    public fillPage(): void {
        let brandId = this.getBrandId();
        this.quizzesEdit.setBrandId(brandId);
        this.getReferences();
    }

    protected getMemoryViewModel() {
        return this.quizzesEdit.getTemplateViewModel();
    }

    protected getReferences(): void {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.loadingIn(this.quizzesEdit.builtTemplate);

        let usrReq_url: string = `/api/brand/${this.getBrandId()}/quizzes/references/`;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesRequestReturn;
        this.XHRHdl.execute();
    }

    protected onReferencesRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.quizzesEdit.setReferences(responseParsed);
                obj.getData();
            });
        };
    }

    protected getData(): void {
        let id: number = 0;
        let pathId = this.getVnAppZone().app.params.id;
        if (pathId !== undefined && !isNaN(pathId)) {
            this.quizzesEdit.setId(pathId);
            id = pathId;
        }

        this.loadingIn(this.quizzesEdit.builtTemplate);

        let brandId = this.getBrandId();
        let usrReq_url: string = `/api/brand/${brandId}/quizzes/get/${id}/`;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed.data);
                obj.loadingOut(obj.quizzesEdit.builtTemplate);
            });
        };
    }

    protected updateList(data): void {
        this.quizzesEdit.setQuiz(data, parseInt(this.getBrandId(), 10));
    }

    public getArticlesSuggestion(keyword, idElement): void {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }


        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/article/";
        let usrReq_params: Array<Array<string>> = [];
        let subViewModel: any = {list: {keyword: keyword}, idElement: idElement, isSubContent: false};

        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onArticleSearchReturn;
        this.XHRHdl.execute();
    }

    protected onArticleSearchReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);
                let articles = [];
                if (response.data.articles) {
                    for (let article of response.data.articles) {
                        article.name = article.title;
                        articles.push(article);
                    }
                }
                obj.quizzesEdit.setArticlesFilter(articles);
            });
        };
    }


    public saveQuiz(regenerate): void {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.quizzesEdit.syncSelectedSourceArticle();
        this.loadingIn(this.quizzesEdit.builtTemplate);
        let usrReq_url: string = `/api/brand/${this.getBrandId()}/quizzes/save/`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.quizzesEdit.getQuizForRequest(regenerate))]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onSaveRequestReturn;
        this.XHRHdl.execute();
    }

    protected onSaveRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.isGenerated) {

                    obj.updateList(responseParsed.data);
                    if (responseParsed.data.id && window.location.pathname.includes("/categorization/quizzes/add/")) {
                        window.history.pushState(
                            "page2",
                            "Emaki CMS",
                            `/brand/${obj.getBrandId()}/categorization/quizzes/edit/${responseParsed.data.id}`
                        );
                    }
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Quiz generated successfully !");
                } else {

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Quiz saved successfully !");

                    page.redirect(`/brand/${obj.getBrandId()}/categorization/quizzes/`);
                }
            });
            obj.loadingOut(obj.quizzesEdit.builtTemplate);
        };
    }

    protected sendNotification(message): void {
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, message);
    }

    public cancel(id = null, brandId = null): void {
        brandId = brandId || this.getBrandId();
        this.releaseLock(id, brandId);
        page.redirect(`/brand/${brandId}/categorization/quizzes/`);
    }

    protected releaseLock(id, brandId): void {
        if (!id) {
            return;
        }

        let usrReq_url: string = `/api/brand/${brandId}/quizzes/release/${id}/`;
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.execute();
    }

    public filterSimpleOnChange(idElement): void {
        if (idElement === "filterArticle") {
            this.quizzesEdit.syncSelectedSourceArticle();
        }
    }

    public filterMultipleSelectorOnChange(idElement) {
    }
}



// WEBPACK FOOTER //
// ./js/modules/quizzes_edit.ts